import { useState } from 'react';
import { Field, FieldProps } from 'formik';
import { validatePincode } from './validate';
import classNames from 'classnames';

export function PinCodeInput() {
    const [showError, setShowError] = useState(false);

    const openShowError = () => {
        if (!showError) {
            setShowError(true);
        }
    }

    return (
        <Field name="pincode" validate={validatePincode}>
            {(props: FieldProps) => {
                const { field: {value, ...field}, form: {isSubmitting}, meta: { error } } = props;
                if (isSubmitting) {
                    openShowError();
                }
                return (
                    <div>
                        <label htmlFor="pincode" className="block mb-2 text-sm font-medium text-gray-900">Postal code *</label>
                        <input
                            type="text"
                            className={
                                classNames(
                                    "bg-gray-50 border text-gray-900 text-sm rounded-lg focus:outline-none focus:ring-1 focus:border w-full p-2.5",
                                    {
                                        "border-gray-300 focus:border-blue-500 focus:ring-blue-500": !(showError && error), 
                                        "border-red-500 focus:border-red-500 focus:ring-red-500": showError && error, 
                                    },
                                )
                            }
                            defaultValue={value}
                            {...field}
                            onFocus={openShowError}
                        />
                        {showError && error && (
                            <p className="mt-1.5 text-xs text-red-600 dark:text-red-500">{error}</p>
                        )}
                    </div>
                );
            }}
        </Field>
    );
}